import React from "react";
import cx from "classnames";
import styles from "./createStoryboard.module.scss";
import { CreateStoryboardDialog } from "./CreateStoryboardDialog";
import { ImportDesignDialog } from "./ImportDesignDialog";
import { useCanCreateStoryboard } from "src/pages/experiences/hooks/useCanCreateStoryboard";

interface CreateStoryboardProps {
  workspaceId: string;
  listId?: string | null;
}

export const CreateStoryboard: React.FC<CreateStoryboardProps> = ({
  workspaceId,
  listId = null,
}) => {
  const [showDialog, setShowDialog] = React.useState(false);
  const [showImportDialog, setShowImportDialog] = React.useState(false);
  const canCreate = useCanCreateStoryboard();

  // Users without create permission don't see the create-from-scratch bar.
  if (!canCreate) return null;

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.bar}>
          <span className={styles.label}>Create from scratch :</span>
          <div className={styles.actions}>
            <div
              className={styles.actionButton}
              onClick={() => setShowDialog(true)}
            >
              <i className={cx("paperflite-shapes", styles.actionIcon)} />
              New Storyboard
            </div>
            <div className={styles.divider} />
            <div
              className={styles.actionButton}
              onClick={() => setShowImportDialog(true)}
            >
              <i className={cx("paperflite-upload", styles.actionIcon)} />
              Import Design
            </div>
          </div>
        </div>
      </div>

      <CreateStoryboardDialog
        show={showDialog}
        onClose={() => setShowDialog(false)}
        workspaceId={workspaceId}
        listId={listId}
      />

      <ImportDesignDialog
        show={showImportDialog}
        onClose={() => setShowImportDialog(false)}
        workspaceId={workspaceId}
      />
    </>
  );
};
